export default __webpack_public_path__ + "images/69c64cbd7c73ce26723e85e18bc77c2b.svg";